const CHUNK_RECOVERY_PREFIX = 'emblem:chunk-recovery:';

const getRecoveryStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.sessionStorage;
  } catch (error) {
    console.warn('Chunk recovery storage unavailable:', error);
    return null;
  }
};

export const isRecoverableChunkError = (error) => {
  const message = String(error?.message || error || '').toLowerCase();
  const name = String(error?.name || '').toLowerCase();

  return (
    name.includes('chunkloaderror') ||
    message.includes('loading chunk') ||
    message.includes('failed to fetch dynamically imported module') ||
    message.includes('importing a module script failed') ||
    message.includes('dynamically imported module')
  );
};

export const recoverFromChunkError = (error, recoveryKey = 'global') => {
  if (typeof window === 'undefined' || !isRecoverableChunkError(error)) {
    return false;
  }

  const storage = getRecoveryStorage();
  const key = `${CHUNK_RECOVERY_PREFIX}${recoveryKey}`;

  if (storage?.getItem(key) === '1') {
    storage?.removeItem(key);
    return false;
  }

  storage?.setItem(key, '1');
  window.location.reload();
  return true;
};

export const clearChunkRecoveryState = (recoveryKey = 'global') => {
  const storage = getRecoveryStorage();
  storage?.removeItem(`${CHUNK_RECOVERY_PREFIX}${recoveryKey}`);
};

export const loadWithChunkRecovery = (loader, recoveryKey = 'global') => {
  if (typeof loader !== 'function') {
    throw new Error('loadWithChunkRecovery expects a loader function.');
  }

  return () =>
    loader()
      .then((module) => {
        clearChunkRecoveryState(recoveryKey);
        return module;
      })
      .catch((error) => {
        if (recoverFromChunkError(error, recoveryKey)) {
          return new Promise(() => {});
        }

        throw error;
      });
};
